import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledStatus = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status }) => {
  return {
    fontSize: "12px",
    color: theme.customColors.grey[700],
    padding: "2.5px 4px",
    borderRadius: "4px",
    width: "fit-content",
    textTransform: "capitalize",

    ...(status === "sent" && {
      backgroundColor: "#D7EDD0",
    }),
    ...(status === "scheduled" && {
      backgroundColor: "#FFF1BE",
    }),
    ...(status === "draft" && {
      backgroundColor: theme.customColors.grey[300],
    }),
    ...(status === "archived" && {
      backgroundColor: "#D5D5D5",
    }),
  };
});
